import { render, staticRenderFns } from "./CompagniaContrattualeForm.vue?vue&type=template&id=0e1ff080&scoped=true"
import script from "./CompagniaContrattualeForm.vue?vue&type=script&lang=js"
export * from "./CompagniaContrattualeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1ff080",
  null
  
)

export default component.exports